import styled, { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`
  .comPlainTextContentEditable {
    -webkit-user-modify: read-write-plaintext-only;
  }

  .comPlainTextContentEditable--has-placeholder::before {
    content: attr(placeholder);
    opacity: 0.5;
    color: inherit;
    cursor: text;
  }
  
  .react_trello_dragClass {
    transform: rotate(3deg);
    zIndex:999;
  }
  
  .react_trello_dragLaneClass {
    transform: rotate(3deg);
    zIndex:999
  }
`

export const BoardDiv = styled.div`
  overflow-y: hidden;
  //padding: 5px;
  // color: #393939;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  //min-height:490px;
  overflow:hidden;
  // background-color: white;
`

export const Header = styled.header`
  margin-bottom: 5px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  min-height:16px;
  border-radius:4px 4px 0 0;
 
`

export const Section = styled.section`
  // background-color: white;
  border-radius: 3px;
  margin: 0 0 0 0;
  position: relative;
  display: inline-flex;
  height: auto;
  max-height: 90%;
  flex-direction: column;


`

export const LaneHeader = styled(Header)`
	z-index: 1000;
  background-color: white;
  padding:3px;
  max-width: 206px;
  height: 50px;
  margin: 3px;
  // border:1px solid #F1F5F6
  background:#fefefe
`

export const LaneFooter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;
  height: 10px;
  display:none
`

export const ScrollableLane = styled.div`
	flex: 1;
	overflow-y: auto;
	overflow-x: hidden;
	align-self: center;
	//max-height: 880px;
  border: ${props => (props.isDraggingOver ? '1px dashed #333' : 'none')};
  //background: ${props => (props.isDraggingOver ? '#fdfdfd' : 'none')};
  //z-index: ${props => (props.isDraggingOver ? '9' : '9')};
  min-width:208px;
	margin-top: 0;
	flex-direction: column;
  justify-content: space-between;
  padding:0;
  min-height:10px
  
`

export const Title = styled.span`
  /*font-weight: bold;*/
font-family: "montserrat-semibold";;
  // line-height: 12px;
  cursor: pointer;
  width: 100%;
  white-space:normal;
`

export const RightContent = styled.span`
  width: 10%;
  text-align: right;
  padding-right: 0;
  background:#007DCF;
  width:24px;
  height:24px;
  color:white;
  text-align:center;
  line-height:22px;
  border-radius:50%
`
export const CardWrapper = styled.article`
  border-radius: 3px;
  // border-top: 1px solid transparent;
  // border-right: 1px solid transparent;
  // border-bottom: 1px solid transparent;
  position: relative;
  // padding: 0px;
  cursor: grab;
  // padding:0 0 0 0;
  width: 200px;
  //background-color: #fefefe;
  // border-radius:0px;
  margin:3px;
  //border: 1px solid #E9EFF2;
  z-index:1;
  // height:50px;
  white-space:normal;
  // max-height:74px;

  &:hover {
  //   -webkit-transition: all 0.5s ease;
  // -moz-transition: all 0.5s ease;
  // -o-transition: all 0.5s ease;
  // -ms-transition: all 0.5s ease;
  // transition: all 0.5s ease;
  //   background-color: #f7f7f7;
  //   box-shadow: 0 0 6px rgba(0, 0, 0, 0.5) !important;
  }
`

export const MovableCardWrapper = styled(CardWrapper)`
  &:hover {-webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  transition: all 0.5s ease;
    //background-color: #EAEDF3;
    box-shadow: 0 0 6px #e2e2e2;
  }
`

export const CardHeader = styled(Header)`
  // border-bottom: 1px solid #eee;
  // padding-bottom: 6px;
`

export const CardTitle = styled(Title)`
  color: black;
  padding:5px
  width: 100%;
`

export const CardRightContent = styled(RightContent)`
  
`

export const Detail = styled.div`
  
  width: 100%;
  min-height:30px;
  padding:2px 0;
  line-height:14px;
  word-break: break-word;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
`

export const Footer = styled.div`
  border-top: 1px solid #eee;
  padding-top: 6px;
  text-align: right;
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  flex-wrap: wrap;
`

export const TagSpan = styled.span`
  padding: 2px 3px;
  border-radius: 3px;
  margin: 2px 5px;
  `

export const AddCardLink = styled.a`
  border-radius: 0 0 3px 3px;
  color: #838c91;
  display: block;
  padding: 5px 2px;
  position: absolute;
  text-decoration: none;
  cursor: pointer;
  bottom: 3px;

  &:hover {-webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  transition: all 0.5s ease;
    //background-color: gray;
    color: #4d4d4d;
    text-decoration: underline;
  }
`
